export const HotJockeys = [
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    },
    {
        hotNo: '111',
        trainerName: 'Justin Snaith',
        last30Runners: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        runnersAtFairviewPoly: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        currentSeason: {
            runs: 30,
            first: 6,
            second: 2,
            third: 6,
            winPercent: 47,
            placePercent: 66
        },
        seq: 4
    }
]